import React from 'react';
import { useTranslation } from 'react-i18next';
import Button, { ButtonTypes } from '@lib/components/Button/Button';
import ActionsRow from '@lib/components/ActionsRow/ActionsRow';

interface Props {
  isEdit?: boolean;
  loading?: boolean;
  onCancel: () => void;
}

function SsoFormActions(props: Props) {
  const { isEdit, loading, onCancel } = props;
  const { t } = useTranslation();
  const actions = [
    <Button
      buttonText={t('cancel')}
      buttonType={ButtonTypes.secondaryOutlined}
      data-test-id="sso__cancel-button"
      disabled={loading}
      fullWidth
      leftIcon="close"
      onClick={onCancel}
    />,
    <Button
      buttonText={isEdit ? t('save-changes') : t('save')}
      buttonType={ButtonTypes.primaryFilled}
      data-test-id="sso__save-button"
      disabled={loading}
      fullWidth
      leftIcon="check"
      type="submit"
    />,
  ];
  return <ActionsRow actions={actions} />;
}

export default SsoFormActions;
